import React from "react";
import "../styles/PricingPlanTemplate.css";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { updatePlan, startFreeTrial, updateUserDetails } from "../services/PersonalDetailsApi";
import { updatePlanTierId, updateCurrentPlanStartDate, updateStripeCustomerId, updateEmailId, updateFirstName, updateIsAuthenticated, updateLastName, updatePhoneNumber, updateUserId } from '../store/userDetailsSlice';
import { allowAccessToPaymentStatusPage } from "../store/navigationSlice";
import { useDispatch, useSelector } from 'react-redux';
import { cancelCurrentSubscription } from "../services/PaymentService";

const PricingPlanTemplate = ({ planName, planShortDesc, price, currentCredits, discountClaimer, features, limitations, backClick, isCurrentPlan, emailId, planTierId, isFirstTimeSubscriber, stripePriceId }) => {

  const discountedPrice = Math.max((price - currentCredits).toFixed(2), 0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { stripeCustomerId: stripeCustomerId = '' } = useSelector((state) => state.userDetails);
  const [showCancelModal, setShowCancelModal] = React.useState(false);

  const explorePlans = () => {
    backClick();
  };

  const goToPaymentPage = () => {
    navigate("/payment", {
      state: {
        itemPrice: price,
        creditsUsed: Math.min(currentCredits, price),
        total: discountedPrice,
        emailId: emailId,
        planTierId: planTierId,
        isFirstTimeSubscriber: isFirstTimeSubscriber,
        stripePriceId: stripePriceId
      }
    });
  };

  const confirmCancelSubscription = async () => {
    await cancelCurrentSubscription(stripeCustomerId);
    setShowCancelModal(false);
    backClick();
  };

  const startTrial = async () => {
    const result = await startFreeTrial(emailId);
    if (result.success) {
      const updates = { isRegistrationComplete: true };
      const response = await updateUserDetails(emailId, updates, dispatch);
      if (response.success) {
        const userDetails = response.data;
        dispatch(updateIsAuthenticated(true));
        dispatch(updateFirstName(userDetails.first_name));
        dispatch(updateLastName(userDetails.last_name));
        dispatch(updateEmailId(userDetails.email));
        dispatch(updatePhoneNumber(userDetails.phone_no));
        dispatch(updatePlanTierId(planTierId));
        dispatch(updateCurrentPlanStartDate(new Date().toISOString()));
        dispatch(updateUserId(userDetails.userId));
        dispatch(updateStripeCustomerId(userDetails.stripeCustomerId));
        dispatch(allowAccessToPaymentStatusPage());
        navigate('/payment-success');
      }
    }
  };

  return (
    <div className="pricing-plan-detail">
      <div className="back-button" onClick={explorePlans}>
        <div className="back-icon"><ArrowBackIcon /></div>
        <div className="back-text">Back</div>
      </div>

      <div className="pricing-plan-card">
        {(planName || "").trim().toLowerCase() === "free" ? (
          <div className="free-plan-content">
            <div className="plan-name">{planName}</div>
            <div className="free-plan-detail">Free User</div>
            <div className="free-plan-detail">Explore all the features upto 7 days.</div>
            <div className="free-plan-detail">"Unlock your potential—go premium today and transform the way you learn, grow, and achieve your goals!"</div>
            {!isCurrentPlan && (
              <div className="plan-payment-button" onClick={startTrial}>
                Start Free Trial
              </div>
            )}
          </div>
        ) : (
          <div className="pricing-plan-container">
            <div className="pricing-plan-content">
              <div className="plan-name">{planName}</div>
              <div className="plan-short-desc">{planShortDesc}</div>
              <div className="plan-price-detail">
                <div className="plan-price-actualPrice">
                  <div>Price</div>
                  <div>$ {price}</div>
                </div>
                <div className="plan-price-currentCredits">
                  <div>Current Credits</div>
                  <div>$ {currentCredits}</div>
                </div>
                {!isCurrentPlan && (
                  <div className="plan-price-discountedPrice">
                    <div>Discounted Price</div>
                    <div>$ {discountedPrice}</div>
                  </div>
                )}
              </div>
              <div className="discount-claimer">{discountClaimer}</div>
              <div className="plan-features">
                <div className="plan-features-header">Features</div>
                <div className="plan-features-list">
                  {features.map((feature, index) => (
                    <div key={index} className="feature-item">{feature}</div>
                  ))}
                </div>
              </div>
              <div className="plan-limitations">
                <span style={{ fontWeight: 700 }}>Limitations:</span> {limitations}
              </div>
            </div>

            {!isCurrentPlan && (
              <div className="plan-payment-button" onClick={goToPaymentPage}>
                Go To Payment Page
              </div>
            )}
            {isCurrentPlan && (
              <div className="cancel-subscription-button" onClick={() => setShowCancelModal(true)}>
                Cancel Subscription
              </div>
            )}
          </div>
        )}
      </div>

      {/* Cancel Subscription Modal */}
      {showCancelModal && (
        <div className="modal-overlay">
          <div className="subscription-modal-content">
            <h3>Confirm Cancellation</h3>
            <p>Are you sure you want to cancel your subscription?</p>
            <div className="modal-buttons">
              <button onClick={() => setShowCancelModal(false)}>No</button>
              <button onClick={confirmCancelSubscription}>Yes</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PricingPlanTemplate;
